module.exports = __webpack_public_path__ + "img/img46.019cc10e.jpg";